export var ValidationOperation;
(function (ValidationOperation) {
    ValidationOperation["TransferClient"] = "transferClient";
    ValidationOperation["SendToWellSky"] = "sendToWellSky";
})(ValidationOperation || (ValidationOperation = {}));
export var ValidationFieldSource;
(function (ValidationFieldSource) {
    ValidationFieldSource["CoreHomeCareLeadField"] = "coreHomeCareLeadField";
    ValidationFieldSource["IntakeQuestion"] = "intakeQuestion";
})(ValidationFieldSource || (ValidationFieldSource = {}));
export var ValidationRuleSeverity;
(function (ValidationRuleSeverity) {
    ValidationRuleSeverity["Hard"] = "hard";
    ValidationRuleSeverity["Warning"] = "warning";
})(ValidationRuleSeverity || (ValidationRuleSeverity = {}));
export var ValidationRuleType;
(function (ValidationRuleType) {
    ValidationRuleType["Required"] = "required";
})(ValidationRuleType || (ValidationRuleType = {}));
export var CoreHomeCareLeadValidationField;
(function (CoreHomeCareLeadValidationField) {
    CoreHomeCareLeadValidationField["ClientName"] = "clientName";
    CoreHomeCareLeadValidationField["ClientPhone"] = "clientPhone";
    CoreHomeCareLeadValidationField["ClientEmail"] = "clientEmail";
    CoreHomeCareLeadValidationField["ClientAddress"] = "clientAddress";
    CoreHomeCareLeadValidationField["ClientDateOfBirth"] = "clientDateOfBirth";
    CoreHomeCareLeadValidationField["BestContactName"] = "bestContactName";
    CoreHomeCareLeadValidationField["BestContactPhone"] = "bestContactPhone";
    CoreHomeCareLeadValidationField["EstimatedStartDate"] = "estimatedStartDate";
    CoreHomeCareLeadValidationField["HoursPerWeek"] = "hoursPerWeek";
    CoreHomeCareLeadValidationField["DaysNeeded"] = "daysNeeded";
})(CoreHomeCareLeadValidationField || (CoreHomeCareLeadValidationField = {}));
export const CoreHomeCareLeadValidationFieldBridgePathsFromHomeCareLeadEntity = {
    [CoreHomeCareLeadValidationField.ClientName]: "selfContactEntity.name",
    [CoreHomeCareLeadValidationField.ClientPhone]: "selfContactEntity.phone1",
    [CoreHomeCareLeadValidationField.ClientEmail]: "selfContactEntity.email1",
    [CoreHomeCareLeadValidationField.ClientAddress]: "selfContactEntity.address1",
    [CoreHomeCareLeadValidationField.ClientDateOfBirth]: "selfContactEntity.birthday",
    [CoreHomeCareLeadValidationField.BestContactName]: "bestContactEntity.name",
    [CoreHomeCareLeadValidationField.BestContactPhone]: "bestContactEntity.phone1",
    [CoreHomeCareLeadValidationField.EstimatedStartDate]: "estimatedStartDate",
    [CoreHomeCareLeadValidationField.HoursPerWeek]: "hoursPerWeek",
    [CoreHomeCareLeadValidationField.DaysNeeded]: "daysNeeded",
};
//# sourceMappingURL=validation-rule.js.map